import React from 'react';
import { Link } from 'react-router-dom';
import styles from './BuyCourseCta.module.css';
import { useTranslation } from 'react-i18next';
import { useLang } from 'hooks/useLang';

const BuyCourseCta = () => {
    const { t } = useTranslation();
    const { lang } = useLang();

    return (
        <section className={styles['buyCourse-section']}>
            <Link to={`/${lang}/programs#course-pricing`} className={styles.buyBtn}>
                <span className={styles.buyBtn__text}>{t('buyCourseCta.textBtn')}</span>
            </Link>
            <Link to={`/${lang}/terms-and-conditions`} className={styles.termsLink}>
                {t('buyCourseCta.termsLink')}
            </Link>
        </section>
    );
};

export default BuyCourseCta;